// HeliodorSDK 3.0 Beta
import 'skyway-js';
import { ETextParamType_SetMicState, ETextParamType_Logined, ETextParamType_CanvasFileName, ETextParamType_CurrentUserName, ETextParamType_HeliodorSDKVersion, worldViewerWindow } from './const';
import { debugLog } from './debugLog';
import { presetBeforeBoot } from './logics/assign';
import { hel_resizeWindow } from './logics/callCGui';
import { getCanvasFileName, getCurrentUserName, getHeliodorSdkVersion, getLoggedInStatusToggle, getWorldId, setCanvasFileName, setMixerTab, setSceneJsonPath } from './logics/dataOps';
import { getMainCanvasDOMElement } from './logics/domOps';
import { requestBootStrapGameEngine, requestToDrawFrame } from './logics/moduleCaller';
import { hel_mixer_LoadCookie_Mute, hel_mixer_LoadCookie_Volume } from './logics/cookieOps';
import { hel_mixer_UpdateAll } from './logics/mixerOps';
import { checkAndInitVR } from './heliodor_xr';
import { hel_prepareVCUID } from './heliodor_core_misc';
/**
 * @remarks
 * JRWorld_web->heliodor_front.jsにて参照
 * JRWorld_web->heliodor_xr.jsにて参照
 * XRWorldIngame->heliodor_front.jsにて参照
 * XRWorldIngame->heliodor_xr.jsにて参照
 * XRWorldIngame->heliodor_xrw_main.jsにて参照
 * front, heliodor_xrw_mainから呼び出しがあるためグローバルにとどめてる
 */ worldViewerWindow.hel_setCanvasFileName = (canvasFileName)=>setCanvasFileName(canvasFileName)
;
const drawFrame = ()=>{
    requestToDrawFrame();
    worldViewerWindow.requestAnimationFrame(drawFrame);
};
/**
 * frontから呼び出しがあるためグローバルにとどめてる
 * @virtual
 */ worldViewerWindow.hel_start = (Type, CharaType, Param1, MultiPlay, StrParam0)=>{
    const mainCanvas = getMainCanvasDOMElement();
    if (mainCanvas === undefined || mainCanvas.width <= 0 || mainCanvas.height <= 0) {
        debugLog('[ hel_start ] mainCanvas is not assigned. noop');
        return;
    }
    const CanTouch = worldViewerWindow.ontouchstart !== undefined;
    setSceneJsonPath('data/' + StrParam0);
    // Initialize
    hel_mixer_LoadCookie_Volume();
    hel_mixer_LoadCookie_Mute();
    hel_prepareVCUID();
    worldViewerWindow.hel_set_show_TextField_configurl(false);
    worldViewerWindow.hel_set_show_TextField_UserName(false);
    // gtag呼び出し
    worldViewerWindow.hel_gtag("Start", {
        param0: getWorldId(),
        param1: MultiPlay
    });
    // Set Parameter
    presetBeforeBoot();
    worldViewerWindow.hel_setText(ETextParamType_Logined, getLoggedInStatusToggle() ? '1' : '0');
    worldViewerWindow.hel_setText(ETextParamType_CanvasFileName, getCanvasFileName());
    worldViewerWindow.hel_setText(ETextParamType_CurrentUserName, getCurrentUserName());
    worldViewerWindow.hel_setText(ETextParamType_HeliodorSDKVersion, getHeliodorSdkVersion());
    //
    requestBootStrapGameEngine(Type, CharaType, Param1, StrParam0, CanTouch, MultiPlay, false);
    //
    mainCanvas.focus();
    drawFrame();
};
/**
 * frontから呼び出しがあるためグローバルにとどめてる
 * @virtual
 */ worldViewerWindow.hel_startScene = (CharaType, MultiPlay, SceneFileName, IsVR = false)=>{
    if (IsVR) {
        checkAndInitVR(SceneFileName, MultiPlay ? 1 : 0);
    } else {
        worldViewerWindow.hel_start(0, CharaType, 0, MultiPlay, SceneFileName);
    }
};
// 即時実行
document.addEventListener('visibilitychange', ()=>{
    if (document.visibilityState === 'hidden') {
        setMixerTab(0.0);
        hel_mixer_UpdateAll();
        // Force MicMute
        worldViewerWindow.hel_skyway_set_mic_state(false);
        worldViewerWindow.hel_setText(ETextParamType_SetMicState, '0');
        worldViewerWindow.hel_canvas_ResetToggleDefault('voicechat');
    } else if (document.visibilityState === 'visible') {
        setMixerTab(1.0);
        hel_mixer_UpdateAll();
    }
}, false);
document.addEventListener('fullscreenchange', ()=>hel_resizeWindow()
);
